import styled from "styled-components";
import { Container } from "../../../components/navbar/Nav.styles";
import PartOne from "../../../assets/partnercom.png";
import PartTwo from "../../../assets/partnercontwo.png";
import PartThree from "../../../assets/partnercompthree.png";
import PartFour from "../../../assets/partnercomfour.png";

export const Partners = () => {
  return (
    <Container>
      <PartContainer>
        <h1>
          Our <span>Trusted Partners</span>
        </h1>
        <div>
          <img src={PartOne} alt="partnerLogo" />
          <img src={PartTwo} alt="partnerLogo" />
          <img className="partner__logo" src={PartFour} alt="partnerLogo" />
          <img src={PartThree} alt="partnerLogo" />
        </div>
      </PartContainer>
    </Container>
  );
};

export const PartContainer = styled.div`
  img {
    max-width: 100%;
  }

  @media screen and (max-width: 991px) {
    .partner__logo {
      width: 92px;
      height: 92px;
    }
  }

  @media screen and (max-width: 579px) {
    .partner__logo {
      width: 92px;
      height: 92px;
    }
  }

  h1 {
    margin-top: 5rem;
    text-align: center;
    font-size: 3rem;
    font-family: "Futura";
    font-weight: 200;
    color: ${({ theme }) => theme.colors.secondary};
    @media screen and (max-width: 579px) {
      margin-left: 0rem;
      margin-right: 0rem;
      font-size: 2.5rem;
    }
  }
  h1 span {
    @media screen and (max-width: 579px) {
      display: block;
    }
  }

  div {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 5rem;
    @media screen and (max-width: 991px) {
      //   height: auto;
      //   display: flex;
      //   flex-wrap: wrap;
      //   //   justify-content: flex-start;
      //   gap: 1rem;
      display: grid;
      grid-template-columns: 45% 37%;
    }
  }
`;
